













import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  setup() {
    const { t } = useI18n()
    return {
      t
    }
  },
  i18n: defineComponentTranslations({
    media_fieldset_description: {
      en:
        'From here you can upload the photos and videos that will appear in the display of your ad. To change the order, click on the image and drag it to where you want it.',
      el:
        'Από εδώ μπορείς να ανεβάσεις τις φωτογραφίες και τα βίντεο που θα εμφανίζονται στην προβολή της αγγελίας σου. Για να αλλάξεις την σειρά, πάτησε πάνω στην εικόνα και τράβηξέ την εκεί που θέλεις.'
    }
  })
})
